import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import { RedirectToRoleHomePage } from './AuthorizedRoute';
import { useUser } from 'hooks/useAccount';
import { Loader } from 'components/Loader';

export const UnauthorizedRoute = () => {
  const { token, role } = useAuth();
  const { isLoading } = useUser(token);

  // If there's a token but user is still loading, show loader
  // This prevents the blank screen issue when RedirectToRoleHomePage returns null
  if (token && isLoading) {
    return <Loader />;
  }

  // we check if the user is logged in, we redirect to home page
  if (token) return <RedirectToRoleHomePage role={role} />;
  return <Outlet />;
};

export default UnauthorizedRoute;
